import tingle from 'tingle.js';
import 'tingle.js/dist/tingle.css';
const modal = (componentClass) => {
    return new tingle.modal({
        footer: false,
        stickyFooter: false,
        closeMethods: ['overlay', 'button', 'escape'],
        closeLabel: "Close",
        cssClass: ['organon-modal', componentClass],
        beforeOpen: function() {
            console.log('beforeOpen');
        },
        onOpen: function() {
            console.log('modal open');
        },
        onClose: function() {
            console.log('modal closed');
        },
        beforeClose: function() {
            // here's goes some logic
            // e.g. save content before closing the modal
            return true; // close the modal
        }
    });
};

export default modal;